import {AttachmentUploadUriApiDto} from "./restModels";

export default class AttachmentUploadUri {
	constructor(public readonly id: string, public readonly uploadUri: string) {}

	public static fromJson(json: AttachmentUploadUriApiDto): AttachmentUploadUri {
		return new AttachmentUploadUri(json.id, json.uploadUri);
	}
}
